(<template>
  <div class="copy-button">
    <button class="copy-button__action"
            :aria-label="textCopy"
            @mouseenter="showTooltip"
            @mouseleave="resetTooltip"
            @click="copy"></button>
    <div v-if="displayTooltip"
         class="copy-button__tooltip">{{ copied ? textCopied : textCopy }}</div>
  </div>
</template>)

<script>
  export default {
    data() {
      return {
        displayTooltip: false,
        copied: false
      };
    },
    computed: {
      textCopy() { return this.$gettext('Copy'); },
      textCopied() { return this.$gettext('Copied!'); },
    },
    methods: {
      copy() {
        this.$emit('clicked');
      },
      showTooltip() {
        this.displayTooltip = true;
      },
      resetTooltip() {
        this.displayTooltip = false;
        this.copied = false;
      }
    }
  };
</script>

<style scoped>
.copy-button {
  position: relative;
}

.copy-button__action {
  width: 16px;
  height: 16px;
  background-image: url(~@assets/imgs/undefined_imgs/copy_icon.svg);
  background-position: center;
  background-repeat: no-repeat;
}

.copy-button__tooltip {
  position: absolute;
  bottom: 125%;
  left: 50%;
  z-index: 2;
  padding: 3px 8px 5px 8px;
  border-radius: 4px;
  background-color: var(--black-700);
  color: var(--color-white);
  font-size: 12px;
  pointer-events: none;
  user-select: none;
  transform: translateX(-50%);
}
</style>
